<template>
  <b-card header-tag="header" class="m-3" no-body>
    <template #header>
      <header-sagres titulo="Cadastrar novo usuário" :botoes="botoesHeader" breakpoint="xl" />
    </template>
    <AbaEditarDadosPessoaisUsuario :usuario="usuario" class="mx-3" @idAtualizado="atualizarIdUsuario" />
  </b-card>
</template>

<script lang="ts">
import { UtilsTS } from '@/utilsts';
import { mixins } from 'vue-class-component';
import { Component, Vue } from 'vue-property-decorator';
import HeaderSagres from '@/components/shared/HeaderSagres.vue';
import { BotaoSagres } from '@/types/botao-sagres';
import { Usuario } from '@/types/administracao/usuarios/usuario';
import AbaEditarDadosPessoaisUsuario from '@/components/administracao/usuarios/AbaEditarDadosPessoaisUsuario.vue'

const CompProps = Vue.extend({
  name: 'NovoUsuario',
  components: { AbaEditarDadosPessoaisUsuario, HeaderSagres },
})

@Component
export default class NovoUsuario extends mixins(UtilsTS, CompProps) {
  botoesHeader: BotaoSagres[] = [
    {
      id: 1,
      icone: 'arrow-left',
      texto: 'Voltar',
      url: `/seguranca-administracao/usuarios`,
    },
  ]
  usuario: Usuario = new Usuario()

  atualizarIdUsuario(novoId: string) {
    this.$router.push(`/seguranca-administracao/usuarios/${novoId}/editar`)
  }
};
</script>

<style scoped></style>